import { render, staticRenderFns } from "./InitialForm.vue?vue&type=template&id=1117b286&scoped=true"
import script from "./InitialForm.vue?vue&type=script&lang=ts"
export * from "./InitialForm.vue?vue&type=script&lang=ts"
import style0 from "./InitialForm.vue?vue&type=style&index=0&id=1117b286&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1117b286",
  null
  
)

export default component.exports